import { AuthLoginEffects } from './login/login.effects';
import { AuthLogoutEffects } from './logout/logout.effects';
import { AuthRecoveryEffects } from './recovery/recovery.effects';
import { AuthRegistrationEffects } from './registration/registration.effects';
import { AuthSettingsEffects } from './settings/settings.effects';
import { AuthVerificationEffects } from './verification/verification.effects';

export const authEffects = [
  AuthLoginEffects,
  AuthLogoutEffects,
  AuthRecoveryEffects,
  AuthRegistrationEffects,
  AuthSettingsEffects,
  AuthVerificationEffects,
];
